module.exports = __webpack_public_path__ + "img/ic-email.0725e51a.svg";